import { render, staticRenderFns } from "./PrivacyConditions.vue?vue&type=template&id=bb6faf90"
import script from "./PrivacyConditions.vue?vue&type=script&lang=js"
export * from "./PrivacyConditions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports